import {push, ref} from 'firebase/database';
import {db} from './firebase';

export const pushResult = async (value: RankItem) => {
  console.log('hey', value);
  push(ref(db, 'sanofi-evento/risultati'), value);
};
